<template>
  <v-dialog :value="dialog" max-width="800px" @input="handler">
    <v-form ref="form" @submit.prevent="submit" v-model="valid">
      <v-card class="card-shadow border-radius-xl">
        <div class="card-header-padding card-border-bottom">
          <span class="font-weight-bold text-h5 text-typo mb-0">{{
            title
          }}</span>
        </div>
        <v-card-text class="card-padding">
          <v-text-field
            v-model="form.name"
            label="资源名称 *"
            color="#4caf50"
            :rules="[(v) => !!v || '资源名称不能为空']"
            class="mediumName"
          ></v-text-field>
          <v-select
            v-model="form.type"
            :items="zyTypeList"
            item-text="name"
            color="#4caf50"
            item-value="type"
            label="资源类型 *"
            no-data-text="暂无数据"
            :rules="[(v) => !!v || '资源类型不能为空']"
            @change="typeChange"
            class="mediumType"
          ></v-select>
          <v-file-input
            truncate-length="15"
            color="#4caf50"
            label="资源上传 *"
            v-if="form.type"
            :accept="fileAccept"
            show-size
            :rules="[(v) => !!v || '请上传资源文件']"
            :value="form.file"
            @change="(f) => (form.file = fileChange(f))"
          ></v-file-input>
        </v-card-text>
        <v-card-actions class="card-padding d-flex justify-end">
          <v-btn
            elevation="0"
            :ripple="false"
            height="35"
            color="success"
            class="font-weight-normal text-capitalize btn-ls py-3 px-6"
            :loading="loading"
            @click="save"
            >保存</v-btn
          >
          <v-btn
            elevation="0"
            :ripple="false"
            height="35"
            class="font-weight-normal text-capitalize btn-ls btn-outline-secondary bg-transparent py-3 px-6"
            @click="close"
            >取消</v-btn
          >
        </v-card-actions>
      </v-card>
    </v-form>
  </v-dialog>
</template>
<script>
import { ossUpload,cancelUpload} from "@/api/common";
import QRcode from 'qrcode'
import { _Base64encode } from '@/util/base64'
export default {
  name: "ResourceLibraryFrom",
  props: {
    dialogEdit: {
      type: Boolean,
      default: false,
    },
    formData: { type: Object, default: () => {} },
    title: {
      type: String,
      default: "",
    },
  },
  data: () => {
    return {
      loading: false,
      form: {
        name: "",
        type: "",
        typeName: "",
        fileName: "",
        size: "",
        accept: "",
        fullPath: "",
        file: "",
      },
      rule: [],
      valid: false,
      zyTypeList: [
        { name: "图片", type: "0" },
        { name: "视频", type: "1" },
        { name: "音频", type: "2" },
        { name: "文档", type: "3" },
        { name: "其他", type: "4" },
        { name: "pdf", type: "5" },
      ],
      fileAccept: "",
      lastModified: "",
      qrBase64: ''
    };
  },
  computed: {
    dialog: {
      get() {
        this.form = this.formData;
        return this.dialogEdit;
      },
    },
  },
  watch: {
    dialogEdit: {
      handler(newVal, oldVal) {
        this.form = this.formData;
        if (this.form.fullPath && newVal) {
          this.getFileFromUrl(this.form.fullPath, this.form.fileName)
            .then((response) => {
              console.log(response);
              this.$set(this.form, "file", response);
              this.lastModified = this.form.file.lastModified;
              this.typeChange(this.form.type)
            })
            .catch((e) => {
              console.error(e);
            });
        }
      },
      immediate: true,
    },
  },
  methods: {
    reset() {
      if (this.$refs.form) {
        this.$refs.form.reset();
        this.$refs.form.resetValidation();
        this.form = {};
      }
    },
    close() {
      cancelUpload()
      this.loading = false;
      this.$emit("closeDialog");
    },
    async save() {
      this.$refs.form.validate();
      if (this.valid) {
        this.loading = true
        if (
          !this.form.fullPath ||
          this.form.file.lastModified != this.lastModified
        ) {
          this.form.fullPath = await this.uploadFile(
            "resourceFile",
            this.form.file
          );
          
         this.form.qrImage = await this.createQRcode('http://file-preview.icubespace.com/onlinePreview?url='+encodeURIComponent(_Base64encode(this.form.fullPath)))
          delete this.form.file;
          this.loading = false
          if (this.formData._id) {
            this.form._id = this.formData._id;
          }
          this.$emit("submit", this.form);
        } else {
          delete this.form.file;
          if (this.formData._id) {
            this.form._id = this.formData._id;
          }
          this.$emit("submit", this.form);
        }
      }
    },
    handler(val) {
      this.$emit("update:dialogEdit", val);
    },
    typeChange(e) {
      this.form.typeName = this.zyTypeList.filter((item) => {
        return item.type === e;
      })[0].name;
      switch (e) {
        case "0":
          this.fileAccept = "image/*";
          break;
        case "1":
          this.fileAccept = "video/*";
          break;
        case "2":
          this.fileAccept = ".MP3,.WAV,.WMA,.MP2,.Flac,.MIDI,.RA,.APE,.AAC,.CDA,.MOV";
          break;
        case "3":
          this.fileAccept = ".txt,.doc,.docx,.pdf,.chm,.wdl";
          break;
        case "4":
          this.fileAccept = "";
          break;
          case "5":
          this.fileAccept = ".pdf";
          break;

        default:
          this.fileAccept = "";
          break;
      }
    },
    fileChange(e) {
      console.log(e);
      if (e) {
        this.form.accept = e.type;
        this.form.fileName = e.name;
        this.form.size = e.size;
      }
      return e;
    },
    // 文件上传
    async uploadFile(fieldName, file) {
      const res = await ossUpload({ path: fieldName, file });
      return res.url;
    },
    // 创建二维码
    createQRcode(content, options) {
      return new Promise((resolve, reject) => {
        QRcode.toDataURL(content, options).then(url => {
          console.log(url)
          resolve(url)
        })
      })
    },
    getFileFromUrl(url, fileName) {
      return new Promise((resolve, reject) => {
        var blob = null;
        var xhr = new XMLHttpRequest();
        xhr.open("GET", url);
        xhr.setRequestHeader("Accept", this.form.accept);
        xhr.responseType = "blob";
        // 加载时处理
        xhr.onload = () => {
          // 获取返回结果
          blob = xhr.response;
          let file = new File([blob], fileName, { type: this.form.accept });
          // 返回结果
          resolve(file);
        };
        xhr.onerror = (e) => {
          reject(e);
        };
        // 发送
        xhr.send();
      });
    },
  },
};
</script>
